const titleCaseWords = (value: string): string =>
  value
    .split(/\s+/)
    .filter(Boolean)
    .map((token) => token.charAt(0).toUpperCase() + token.slice(1).toLowerCase())
    .join(' ');

export const formatEventLabel = (eventType: string): string => {
  if (!eventType) return 'Event';
  return titleCaseWords(eventType.replace(/[._-]+/g, ' '));
};
